// Funktion zum Setzen des z-index für die Klasse 'order-logic-sweet-alert'
function setZIndexForSweetAlert() {
  const elements = document.querySelectorAll('.order-logic-sweet-alert');
  elements.forEach(el => {
    el.style.zIndex = '2147483647';
  });
}

// MutationObserver einrichten
const observer = new MutationObserver((mutations) => {
  mutations.forEach((mutation) => {
    if (mutation.type === 'childList' || mutation.type === 'subtree') {
      setZIndexForSweetAlert();
    }
  });
});

// Optionen für den Observer (Überwachung auf Veränderungen in den Child-Elementen)
const config = { childList: true, subtree: true };

// Das Dokument oder einen spezifischen Container überwachen
observer.observe(document.body, config);

// Initiales Setzen des z-index beim Laden der Seite
setZIndexForSweetAlert();







